// components/OnDemandTour/UrlMatchingStrategySelector.tsx

import {
    Col,
    Form, Radio, Row,
    Select, Space, Typography,
} from 'antd';
import { EUrlMatchStrategy } from '../../../../enums/tours.enum';

const { Text } = Typography;

interface IUrlMatchStrategyOption {
    value: EUrlMatchStrategy;
    label: string;
    description: string;
    recommended?: boolean;
  }

const URL_MATCH_STRATEGY_OPTIONS_LIST: IUrlMatchStrategyOption[] = [
    {
        value: EUrlMatchStrategy.PATHNAME,
        label: 'Pathname only',
        description: 'Ignores query parameters',
        recommended: true,
    },
    {
        value: EUrlMatchStrategy.EXACT,
        label: 'Exact match',
        description: 'URL must match exactly',
    },
    {
        value: EUrlMatchStrategy.CONTAINS,
        label: 'Contains specific params',
        description: 'Pathname + specific query params must exist',
    },
    {
        value: EUrlMatchStrategy.PATTERN,
        label: 'Pattern matching',
        description: 'Use wildcards (advanced)',
    },
];

interface UrlMatchingStrategySelectorProps {
  value: EUrlMatchStrategy;
  onChange: (value: EUrlMatchStrategy) => void;
  availableParams: string[];
  selectedParams: string[];
  onParamsChange: (params: string[]) => void;
}

const UrlMatchingStrategySelector: React.FC<UrlMatchingStrategySelectorProps> = ({
    value,
    onChange,
    availableParams,
    selectedParams,
    onParamsChange,
}) => (
    <>
        <Form.Item
            label="URL Matching Strategy"
            tooltip="Choose how strict the URL matching should be"
        >
            <Radio.Group
                value={value}
                onChange={(e) => onChange(e.target.value)}
                style={{ width: '100%' }}
            >
                <Row gutter={[16, 16]}>
                    {URL_MATCH_STRATEGY_OPTIONS_LIST.map((option) => (
                        <Col key={option.value} span={12}>
                            <Radio value={option.value} style={{ width: '100%' }}>
                                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                                    <Space size={8} align="center">
                                        <Text strong>{option.label}</Text>
                                        {option.recommended && (
                                            <Text
                                                style={{
                                                    fontSize: '10px',
                                                    color: '#52c41a',
                                                    fontWeight: 'bold',
                                                    padding: '2px 8px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #52c41a',
                                                }}
                                            >
                                                Recommended
                                            </Text>
                                        )}
                                    </Space>
                                    <Text
                                        type="secondary"
                                        style={{
                                            fontSize: '12px',
                                            display: 'block',
                                            lineHeight: '1.4',
                                        }}
                                    >
                                        {option.description}
                                    </Text>
                                </Space>
                            </Radio>
                        </Col>
                    ))}
                </Row>
            </Radio.Group>
        </Form.Item>

        {value === EUrlMatchStrategy.CONTAINS && availableParams.length > 0 && (
            <Form.Item
                label="Required Query Parameters"
                help="Select which query parameters must be present"
            >
                <Select
                    mode="multiple"
                    placeholder="Select required params"
                    value={selectedParams}
                    onChange={onParamsChange}
                >
                    {availableParams.map((param) => (
                        <Select.Option key={param} value={param}>
                            {param}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
        )}
    </>
);

export default UrlMatchingStrategySelector;
